import MuseumArtworkTile from "./MuseumArtworkTile";

export default MuseumArtworkTile;
